import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'model/state';
import User from "model/User";
import { selectIsAuthenticated, selectIsAuthSubmitting as selectIsSubmitting, selectLoggedUser} from 'selectors/Auth';
import { userSignIn } from 'actions/Auth';
import { Credentials, Message } from 'model';
import { Dispatch } from 'redux';
import { clearMessage, openConfirmationDialog, showMessage } from 'actions/Common';
import { requestResetPassword } from 'actions';
import { Login } from 'components';

const mapStateToProps = createStructuredSelector<RootState, { isAuthenticated: boolean, isSubmitting: boolean, authenticatedUser: User | undefined }>({
  isAuthenticated: selectIsAuthenticated(),
  isSubmitting: selectIsSubmitting(),
  authenticatedUser: selectLoggedUser()
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  userSignIn: (credentials: Credentials) => dispatch(userSignIn(credentials)),
  clearMessage: () => dispatch(clearMessage()),
  openConfirmationDialog: (metadata?: { [key: string]: any }) => dispatch(openConfirmationDialog(metadata)),
  requestResetPassword: (email: string, locale: string) => dispatch(requestResetPassword(email, locale)),
  showMessage: (message: Message) => dispatch(showMessage(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
